import Decimal from '../../../packs_helper/scripts/Decimal';
import RelativeDate from "../../../packs_helper/scripts/RelativeDate";
import PostData from "../../../packs_helper/scripts/PostData";

window.CalculatePrice = (quantity) => {
	const calculatedBys = document.querySelectorAll(`[data-calculated-by]`);
	calculatedBys.forEach(calculatedBy => {
		const price = quantity * Decimal(calculatedBy.dataset.unitPrice);
		if(!price){
			calculatedBy.innerText = `${Decimal(calculatedBy.dataset.unitPrice).toFixed(2)} ₺`;
		}
		else{
			calculatedBy.innerText = `${price.toFixed(2)} ₺`;
		}
	})
}

window.ToggleFavorite = (product_id) => {
	let favorite_count = document.getElementById("favorite_count");
	let result_count = 0;
	PostData('/favorilere-ekle', {product_id}).then(response => {
		let favorite_icon, favorite_title, favorite_class;
		if(response.status === 1){
			favorite_icon = "#gs-icon-product-detail-heart-full";
			favorite_title = "Favoriden Kaldır";
			favorite_class = "icon favorite-icon-selected";
			if(parseInt(favorite_count.getAttribute("count")) !== ""){
				result_count = parseInt(favorite_count.getAttribute("count")) + 1;
				favorite_count.innerHTML = result_count;
				favorite_count.setAttribute("count", result_count)
			}else{
				favorite_count.innerHTML = 1;
				favorite_count.setAttribute("count", 1);
			}
			document.getElementById("favorite_"+product_id).setAttribute("title", favorite_title);
			document.getElementById("favorite_icon_"+product_id).setAttribute("class", favorite_class);
			document.getElementById("favorite_icon_result_"+product_id).setAttribute("xlink:href", favorite_icon);
		}else if(response.status === 0){
			favorite_icon = "#gs-icon-product-detail-heart";
			favorite_title = "Favorilere Ekle";
			favorite_class= "icon favorite-icon";
			document.getElementById("favorite_"+product_id).setAttribute("title", favorite_title);
			document.getElementById("favorite_icon_"+product_id).setAttribute("class", favorite_class);
			document.getElementById("favorite_icon_result_"+product_id).setAttribute("xlink:href", favorite_icon);
			if((favorite_count.getAttribute("count") - 1) !== 0){
				result_count = parseInt(favorite_count.getAttribute("count")) - 1
				favorite_count.innerHTML = result_count;
				favorite_count.setAttribute("count", result_count);
			}else{
				favorite_count.innerHTML = "";
				favorite_count.setAttribute("count", 0);
			}
		}

	}).catch(err => {
		this.disabled = false;
	})
}

const lastSeenEl = document.getElementById('last-seen');
let lastSeenResult = RelativeDate(String(lastSeenEl.dataset.seen));
if(
	lastSeenResult == "Şimdi" 
	|| lastSeenResult.includes("sn önce") 
	|| (lastSeenResult.includes("dk önce") && parseInt(lastSeenResult.substr(0,2)) < 6)
  ){ 
	lastSeenResult = '<i class="online" title="Online"></i> Çevrimiçi';
	document.getElementById('last-seen-text').innerHTML = ""
}
lastSeenEl.innerHTML = lastSeenResult;